import Vue from 'vue';
import VueRouter from "vue-router";
import Vuelidate from "vuelidate";

import App from './views/App.vue'
import router from './router'
import store from "./store";

import ApiService from "./common/service.api";
import vuetify from './plugins/vuetify';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import i18n from './lang/i18n';

import CKEditor from '@ckeditor/ckeditor5-vue2';

// Set Vue globally
window.Vue = Vue;

import $ from 'jquery';
window.$ = window.jQuery = $;

// set router
Vue.router = router;
Vue.use(VueRouter);

Vue.use(Vuelidate);

// axios
ApiService.init();

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  store,
  i18n,
  Vuelidate,
  watch:{
    '$route' (to){
      this.$store.dispatch('setPage', to.name);
    }
  },
  render: h => h(App)
}).$mount('#app');

//Print
import VueHtmlToPaper from 'vue-html-to-paper';

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
};

Vue.use(VueHtmlToPaper, options);

// Date picker
import DatetimePicker from 'vuetify-datetime-picker'
// (Optional) import 'vuetify-datetime-picker/src/stylus/main.styl'

Vue.use(DatetimePicker);

// Excel
import excel from 'vue-excel-export'

Vue.use(excel)

// filter current
Vue.filter('currency', function (value) {
  if (value) {
    value = parseInt(value);
    let floatValue = (value).toFixed(1).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return floatValue.substring(0, floatValue.length - 2) + " đ";
  } else {
    return value;
  }

});

// filter currency_init
Vue.filter('currency_init', function (value) {
  if(value) {
    value = parseInt(value);
    let floatValue = (value).toFixed(1).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return floatValue.substring(0, floatValue.length - 2);
  } else {
    return value;
  }

});

// CKEditor
Vue.use( CKEditor );
